import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as React from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ height: "calc(100% - 48px)" }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0, height: "100%" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

type TabPanelChildrenProps = {
  id: number;
  children: JSX.Element | JSX.Element[];
};

type BasicTabsProps = {
  tabs: string[];
  TabPanels: TabPanelChildrenProps[];
};

export default function BasicTabs({ tabs, TabPanels }: BasicTabsProps) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ flex: 1, maxHeight: "calc(100% - 40px)" }}>
      <Box>
        <Tabs
          sx={{ overflow: "hidden", marginBottom: "0px" }}
          value={value}
          variant="fullWidth"
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {tabs.map((tab, index) => (
            <Tab
              sx={{ fontFamily: "NotoSans-Medium", fontSize: "14px" }}
              label={tab}
              key={index}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
      </Box>
      {TabPanels.map((panel, index) => (
        <TabPanel value={value} key={index} index={panel.id}>
          {panel.children}
        </TabPanel>
      ))}
    </Box>
  );
}
